import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { submitFeedback } from '../../common/api';
import { userEmail } from '@repo/utils';
import './FeedbackModal.css';

const FEEDBACK_TYPES = [
    { value: 'bug', label: 'Bug 反馈' },
    { value: 'feature', label: '功能建议' },
    { value: 'other', label: '其他' },
];

function FeedbackModal({ show, onHide }) {
    const [email] = useState(userEmail());
    const [type, setType] = useState('bug');
    const [content, setContent] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!content.trim()) return;
        setSubmitting(true);
        setResult(null);
        try {
            await submitFeedback(email, content, type);
            setResult({ success: true, message: '反馈已提交，感谢您的建议！' });
            setContent('');
        } catch (err) {
            const msg = err?.response?.data?.message || err?.message || '提交失败，请稍后重试';
            setResult({ success: false, message: msg });
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        setResult(null);
        setContent('');
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>用户反馈</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {result && (
                        <Alert variant={result.success ? 'success' : 'danger'}>
                            {result.message}
                        </Alert>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>邮箱</Form.Label>
                        <Form.Control type="email" value={email} disabled />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>反馈类型</Form.Label>
                        <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
                            {FEEDBACK_TYPES.map((t) => (
                                <option key={t.value} value={t.value}>{t.label}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>反馈内容</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="请描述您遇到的问题或改进建议..."
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>取消</Button>
                    <Button variant="primary" type="submit" disabled={submitting || !content.trim()}>
                        {submitting ? '提交中...' : '提交反馈'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default FeedbackModal;
